import * as React from 'react';
import { useSelector } from 'react-redux';

import { IPhoneSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { CallButton } from '../../../components/NewbuildingPromos/parts/CallButton';
import { getDynamicCalltrackingSiteBlockId } from '../../../selectors/getDynamicCalltrackingSiteBlockId';
import { getOffer, getOfferPhones } from '../../../selectors/newObject';
import { getAgent } from '../../../selectors/newObject/getAgent';
import { getFormattedPhoneNumber } from '../../../utils/formatters';
import { getCustomUrl } from '../../../utils/tracking/getCustomUrl';
import { trackPhoneOpen } from '../../../utils/tracking/promos/trackPhoneOpen';

export const PromosBannerCallButton = () => {
  const [isPhonesVisible, handlePhonesVisible] = React.useState(false);

  const offer = useSelector(getOffer);
  const phones = useSelector(getOfferPhones);
  const siteBlockId = useSelector(getDynamicCalltrackingSiteBlockId);
  const agent = useSelector(getAgent);
  const filteredPhones = phones && phones.filter((phone: IPhoneSchema) => !!phone.number);
  const phone = (phones as IPhoneSchema[]).map(getFormattedPhoneNumber).join(', ');
  const gaLabel = getCustomUrl(offer, agent);

  const handleShowPhoneClick = React.useCallback(() => {
    handlePhonesVisible(true);
    trackPhoneOpen({ label: gaLabel, action: 'Open_promotions_block' });
  }, [gaLabel]);

  if (!filteredPhones || !filteredPhones.length) {
    return null;
  }

  return (
    <CallButton
      handleShowPhoneClick={handleShowPhoneClick}
      isPhonesVisible={isPhonesVisible}
      phone={phone}
      announcementId={offer.id}
      siteBlockId={siteBlockId}
    />
  );
};
